import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { I as a } from "./inline-message-BYLpwrsI.mjs";
function f({ message: s, showIcon: e = !1, status: r = "error", ...t }) {
  return /* @__PURE__ */ o.jsx(
    a,
    {
      icon: e === !1 ? !1 : void 0,
      status: r,
      title: s,
      ...t
    }
  );
}
export {
  f as S
};
//# sourceMappingURL=status-message-BMoS1d1Y.mjs.map
